import React, { useContext, useState, useEffect, useCallback, useRef } from 'react'
import debounce from 'lodash/debounce'
import { connect } from 'react-redux'
import { TextField } from '@mui/material'
import { Autocomplete } from '@mui/material'

import { AuthContext } from 'contexts/auth'

import { grantedOrganisationsActions } from 'state/grantedOrganisations'
import { ListboxComponent } from 'utilities/autocompleteListInput/helpers'

import type { Organisation } from 'types'

type Props = {
  fetchOrganisations: (query: string) => void;
  setOrganistationIds: (values: string[]) => void;
  organisations: Organisation[];
};

const SwitchOrgranisationInput = (props: Props) => {
// @ts-expect-error - TS2339 - Property 'selectedOrganisations' does not exist on type 'unknown'.
  const { selectedOrganisations = [] } = useContext(AuthContext)
  const {
    organisations = [],
    fetchOrganisations,
    setOrganistationIds
  } = props

  const [inputValue, setInputValue] = useState('')

// @ts-expect-error - TS7006 - Parameter 'org' implicitly has an 'any' type.
  selectedOrganisations.forEach(org => {
    if (!organisations.find(({ id }) => id === org.id)) organisations.push(org)
  })

  const options = organisations.map(({ id, name }) => ({ key: id, label: name, value: id }))
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
  const selectedOptions = selectedOrganisations.map(({ id }) => options.find(({ key }) => key === id))

  const onChange = (_: any, options: any) => {
// @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type.
    const values = (options || []).map(({ value }) => value)
    setOrganistationIds(values)
  }

  const handleInputChange = (_: any, newValue: string) => {
    setInputValue(newValue)
  }

  // eslint-disable-next-line
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
  const filterOptions = useRef(useCallback(debounce((inputValue) =>
    fetchOrganisations(inputValue), 500, { leading: true, maxWait: 1500 })))

  useEffect(() => {
    filterOptions.current(inputValue)
  }, [inputValue])

  return (
    <Autocomplete
      multiple
      filterSelectedOptions
      getOptionLabel={({ label }) => label || ''}
      options={[...selectedOptions, ...options]}
// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Props & RefAttributes<HTMLDivElement>>' is not assignable to type 'JSXElementConstructor<HTMLAttributes<HTMLElement>> | undefined'.
      ListboxComponent={ListboxComponent}
      renderInput={
        params =>
          <TextField
// @ts-expect-error - TS2783 - 'fullWidth' is specified more than once, so this usage will be overwritten.
            fullWidth
            {...params}
            label='Switch Organisations'
            variant='outlined'
          />
      }
      isOptionEqualToValue={(option, value) => option.key === value.key}
      defaultValue={selectedOptions}
      onInputChange={handleInputChange}
      onChange={onChange}
    />
  )
}

const mapStateToProps = (state: any) => ({
  organisations: state.grantedOrganisations.data,
})

const mapDispatchToProps = {
  fetchOrganisations: grantedOrganisationsActions.fetchGrantedOrganisations
} as const

export default connect(mapStateToProps, mapDispatchToProps)(SwitchOrgranisationInput)
